import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import tw from 'twin.macro';
import { ServiceType } from '../../../__generated__/graphql';
import {
  Card,
  CardBody,
  CardDescription,
  CardTitle,
  PageContainer,
  Stack,
} from '../../components/ui';
import { getBrand } from '../../constants/brands';
import { SERVICE_TYPE_DESCRIPTIONS, SERVICE_TYPE_LABELS } from '../ServiceProviderPage/priceTables';
import { ServiceSearchBar } from './ServiceSearchBar';
import { defaultServiceSearch, searchPath } from './serviceSearchState';

const Hero = styled.section`
  ${tw`flex flex-col gap-3 py-8 sm:py-12`}
`;

const Headline = styled.h1`
  ${tw`text-3xl font-bold sm:text-5xl`}
  color: var(--color-text-primary);
  font-family: var(--font-display);
  letter-spacing: -0.02em;
`;

const Sub = styled.p`
  ${tw`text-base sm:text-lg`}
  max-width: 680px;
  color: var(--color-text-secondary);
`;

const Grid = styled.div`
  ${tw`grid grid-cols-1 gap-4 sm:grid-cols-3`}
`;

/**
 * The services site home for customers (spec 019 W10): the search bar and the
 * three services. Signed out works: search and prices by ZIP code (D21).
 */
export default function ServiceHomePage() {
  const navigate = useNavigate();
  const brand = getBrand();
  const start = defaultServiceSearch();
  return (
    <PageContainer width="lg" data-testid="service-home">
      <Stack $gap={8}>
        <Hero>
          <Headline>{brand.copy.heroHeadline}</Headline>
          <Sub>{brand.copy.heroSubcopy}</Sub>
        </Hero>
        <ServiceSearchBar value={start} onSearch={state => navigate(searchPath(state))} />
        <Grid>
          {[ServiceType.HomeTurnover, ServiceType.VehicleCleaning, ServiceType.VehicleHandover].map(
            type => (
              <Card
                key={type}
                $interactive
                onClick={() => navigate(searchPath({ ...start, serviceType: type }))}
                style={{ cursor: 'pointer' }}
              >
                <CardBody>
                  <CardTitle>{SERVICE_TYPE_LABELS[type]}</CardTitle>
                  <CardDescription>{SERVICE_TYPE_DESCRIPTIONS[type]}</CardDescription>
                </CardBody>
              </Card>
            ),
          )}
        </Grid>
      </Stack>
    </PageContainer>
  );
}
